import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataService, DebtRecord, PartnerRecord } from '@core/services/data.service';
import { UsersService } from '@core/services/users.service';
import { MessageBoxService } from '@routes/common/message-box.service';
import { map } from 'rxjs/operators';
import { ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit {

  @Input()
  public debt: DebtRecord;

  @Input()
  public partner: PartnerRecord;

  @Input()
  public counters: { Stamp: number, Tag: string, Amount: number }[] = [];

  @Output()
  public deleted = new EventEmitter<DebtRecord>();

  constructor(private users: UsersService, private ds: DataService, private ms: MessageBoxService, private decimal: DecimalPipe, private modal: ModalService) { }

  ngOnInit(): void {
  }

  public get deletable(): boolean {
    return this.users.current.Roles.contains("Owner");
  }

  public get countered(): number {
    return this.counters.sum(i => i.Amount);
  }

  public get left(): number {
    return this.total - this.countered;
  }

  public get total(): number {
    return Math.abs(this.debt.Total);
  }

  public delete() {

    this.ms.confirms('discourage', "Bạn muốn xóa khoản công nợ <b>" + this.decimal.transform(this.debt.Total, '1.0-0', 'en-US') + ' ' + this.debt.Icon + "</b> của <b>" + this.partner.Name + "</b>?", () => this.ds.debts('delete', this.debt).pipe(map(result => {
      if (result && result.length == 1) {
        this.modal.of(this).hide();
        this.deleted.emit(this.debt);        
        return true;
      }

      return false;
    })));    
  }
}
